import { Fragment } from "react";
import { Avatar } from "primereact/avatar";

import { Card, CardBody } from "reactstrap";

import driver from "assets/images/driver.png";

import Breadcrumbs from "Components/Breadcrumbs";

import { CREATE_DRIVER, EDIT_DRIVER, MY_DRIVERS } from "Constant";

import { API, COLUMNS, CREATE_TAXI_DRIVER } from "./data";

// import SimpleDataTable from "Components/DataTables/SimpleDataTable";
import ModalApp from "Components/ModalApp";
import AddItem from "Components/AddItemWithZod";
import EditItem from "Components/EditItemWithZod";
import UploadAvatar from "Components/UploadDoc/UploadAvatar";

import { gridItem, listItem } from "./CardUser";
import DateView from "Components/DateView";
import LeftToolBar from "./LeftToolBar";

const UsersPage = () => {
  const breadCrumbsProps = [MY_DRIVERS];

  const { list } = API;

  const getOldData = (data) => {
    try {
      const res = {
        ...data.data.results.data,
        taxi: data.data.results.data.taxi.code,
      };

      return res;
    } catch (error) {
      return [];
    }
  };

  return (
    <Fragment>
      <Card>
        <CardBody>
          <Breadcrumbs breadCrumbsProps={breadCrumbsProps} />

          <DateView
            LeftToolBar={LeftToolBar}
            link={list}
            gridItem={gridItem}
            listItem={listItem}
          />
        </CardBody>
      </Card>

      <ModalApp type="editUser" title={EDIT_DRIVER}>
        <EditItem itemsUpdate={CREATE_TAXI_DRIVER} getOldData={getOldData} />
      </ModalApp>

      <ModalApp size="lg" type="editUserImg" title={EDIT_DRIVER}>
        {/* <EditItem itemsUpdate={CREATE_TAXI_DRIVER} /> */}
        <UploadAvatar fileName="proof" />
      </ModalApp>

      <ModalApp type="createDriver" title={CREATE_DRIVER} size="xl">
        <AddItem addURL={API.create} items={CREATE_TAXI_DRIVER} />
        {/* <CreateDriver /> */}
      </ModalApp>
    </Fragment>
  );
};

export default UsersPage;
